<script>
  import { preferences } from '$lib/stores'
  import { Icon } from '@pogzul/artboard'
</script>

<button class="btn btn-square btn-sm" on:click={() => preferences.value = { ...preferences.value, ide_visible: !preferences.value.ide_visible }}>
  <Icon name="terminal" class="h-5 w-5" />
</button>